<div class="row row-gap-3">
  <div class="col-12 col-lg-6" *ngFor="let task of tasks">
    <mat-card>
      <mat-card-header>
        <div
          class="header-container"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxFlex="100"
        >
          <mat-toolbar>
            <div class="d-flex justify-content-between w-100">
              <div class="title d-flex align-items-center" mat-card-title>
                <!-- <jam-icon [name]="method.icon" /> -->
                {{ task.persianName }}
              </div>
              <div class="card-action">
                <jam-icon
                  name="pen"
                  color="accent"
                  mat-ripple
                  (click)="editTask(task)"
                />
                <jam-icon
                  name="trash"
                  color="warn"
                  mat-ripple
                  (click)="deleteTask(task)"
                />
              </div>
            </div>
          </mat-toolbar>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="card-data container my-3">
          <div class="label">نام انگلیسی</div>
          <div>{{ task?.englishName }}</div>
          <div class="label">امتیاز</div>
          <div>{{ task?.score | number : "1." }}</div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-12 col-lg-6">
    <mat-card class="add-card" (click)="addNewTask()">
      <div class="plus-sign-oncard">+</div>
    </mat-card>
  </div>
</div>
